import { TimePicker } from 'antd';
import { t } from '../../../i18n/i18n';
import TreeMultiSelect from '../../TreeMultiSelect/TreeMultiSelect';
import DropDownSelect from '../../DropdownSelect/DropdownSelect';
import MultipleSelect from '../../MultipleSelect/MultipleSelect';
import { CategoriesIdDefined, TAGS_TYPE } from '../../../constants/enums';
import GenericToggle from '../../GenericToggle/GenericToggle';
import { convertToMoment } from '../../../utils/time';

export const TestGroupSetting = ({
  testGroupData,
  newScreening,
  handleSelectMinimumTierOption,
  handleSelectLevelOption,
  testGroupLevelsFilterOptions,
  testGroupCategoriesFilterOptions,
  onSelectCategories,
  handleSelectCategoryOption,
  optionsCategorySelect,
  handleCustomTestGroupTime,
  testGroupRolesFilterOptions,
  challengeAlkemy,
  handleSelectRolesOptionsMultiple,
  handleSelectTagsOptions,
  testGroupTagsFilterOptions,
  handleSelectEndorsementOptions,
  endorsementCreatorsOptions,
  handleSelectCompanyUsageOptions,
  endorsementCompaniesOptions,
  setTestgroupWithThemes,
  testgroupWithThemes,
  isEdit,
  handleModifyData,
  handleHideTitle,
  handleIsAutomaticContinue,
  handleWithoutTime,
  setChallengeAlkemy,
  technologies,
  handleFilterChange,
  techChallengeAlkemy,
  setTechnologies,
  readOnly = false,
}) => (
  <>
    <div className="d-flex align-items-center">
      <DropDownSelect
        selectedPlaceholder
        className="mr-4"
        placeholder={t('SELECT_MINIMUM_TIER_PLACEHOLDER')}
        disabled={readOnly}
        setState={handleSelectMinimumTierOption}
        selected={testGroupData?.minimumTier}
        options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((item) => ({
          key: item,
          id: item,
          name: `Tier N° ${item}`,
        }))}
      />
      <DropDownSelect
        selectedPlaceholder
        className="mr-2"
        placeholder={t('MULTIPLE_SELECT_LEVELS_PLACEHOLDER')}
        setState={handleSelectLevelOption}
        selected={testGroupData?.level}
        disabled={readOnly}
        options={testGroupLevelsFilterOptions?.map((item) => ({
          key: item.id,
          id: item.id,
          name: item.displayName,
        }))}
      />
      <TreeMultiSelect
        options={testGroupCategoriesFilterOptions?.filter(
          (category) =>
            category?.id !== CategoriesIdDefined.CUSTOM &&
            category?.id !== CategoriesIdDefined.CHALLENGE_ASYNC_AI
        )}
        value={testGroupData?.categories}
        textSize="14px"
        width="150"
        treeCheckStrictly
        onChange={(values) => onSelectCategories(values?.map((item) => item?.value))}
        className=" drops-filter flex-row mr-2 text-xs"
        style={{ fontSize: 12, minWidth: 120 }}
        label={t('MULTIPLE_SELECT_CATEGORIES_PLACEHOLDER')}
        dropdownWidth="300px"
        disabled={readOnly}
      />
      <div style={{ minWidth: 170 }} className="mx-2 ">
        <DropDownSelect
          selectedPlaceholder
          placeholder={t('MULTIPLE_SELECT_CATEGORIES_PLACEHOLDER_DEFAULT')}
          setState={handleSelectCategoryOption}
          selected={testGroupData?.category}
          options={[
            {
              value: '-1',
              label: t('MULTIPLE_SELECT_CATEGORIES_PLACEHOLDER_DEFAULT'),
            },
            ...optionsCategorySelect,
          ]}
          width="100%"
          disabled={readOnly}
        />
      </div>

      <div className="d-flex align-items-center my-2">
        <span className=" font-italic text-muted font-weight-bold text-xs">
          {t('CREATE_SCREENING_YOUR_QUESTIONS_TOTAL_TIME')}
        </span>
        <TimePicker
          onChange={handleCustomTestGroupTime}
          defaultValue={convertToMoment(newScreening.customTestGroupDuration)}
          disabled={readOnly}
        />
      </div>
    </div>
    <div className="d-flex align-items-center">
      {!challengeAlkemy && (
        <div className="mx2">
          <TreeMultiSelect
            treeCheckStrictly
            options={testGroupRolesFilterOptions}
            value={testGroupData?.rolesIds}
            textSize="12px"
            onChange={(values) =>
              handleSelectRolesOptionsMultiple(values?.map((item) => item?.value))
            }
            className="drops-filter flex-row mr-2 text-xs"
            label={t('ROLES_FILTERS')}
            labelName="displayName"
            width="100%"
            dropdownWidth="300px"
            style={{ minWidth: 160 }}
            disabled={readOnly}
          />
        </div>
      )}
      {!challengeAlkemy && (
        <MultipleSelect
          title={t('TAGS')}
          classNames="mx-2 bg-white"
          onSelect={(e) => handleSelectTagsOptions(e.id)}
          selectedList={testGroupData?.tagsIds}
          options={testGroupTagsFilterOptions?.filter((item) => item?.type === TAGS_TYPE.MARKETING)}
          isCreateTestGroup
          disabled={readOnly}
        />
      )}
      {!challengeAlkemy && (
        <DropDownSelect
          selectedPlaceholder
          className="mx-2"
          placeholder={t('ENDORSEMENT_CREATOR')}
          setState={handleSelectEndorsementOptions}
          selected={testGroupData?.endorsementId}
          options={endorsementCreatorsOptions}
          disabled={readOnly}
        />
      )}

      {!challengeAlkemy && (
        <MultipleSelect
          title={t('Compañia')}
          classNames="mx-2 bg-white"
          onSelect={(e) => handleSelectCompanyUsageOptions(e.id)}
          selectedList={testGroupData?.companyUsageIds}
          options={endorsementCompaniesOptions?.map((item) => ({
            ...item,
            displayName: item?.name,
          }))}
          isCreateTestGroup
          disabled={readOnly}
        />
      )}
      <div className="d-flex mb-2 align-items-center">
        <GenericToggle
          actionFunction={() => setTestgroupWithThemes(!testgroupWithThemes)}
          defaultActive={testgroupWithThemes}
          isEditTG={isEdit || challengeAlkemy}
          disabled={readOnly}
        />
        <span
          className={` text-xs font-weight-500 ${testgroupWithThemes ? 'text-dark' : 'text-muted'}`}
        >
          {t('ABM_THEME_SWITCH_TEXT')}
        </span>
      </div>
    </div>
    {!challengeAlkemy && (
      <div className="d-flex align-items-center">
        <span className=" font-italic text-muted font-weight-bold text-xs mx-2">
          {t('WORKSPACE_ID')}
        </span>
        <input
          maxLength={5}
          value={testGroupData?.workspaceId}
          name="workspaceId"
          onChange={handleModifyData}
          className={`p-2  rounded workspace-id-input mt-2 text-xs ${
            testGroupData?.workspaceId?.length >= 1 && 'completed'
          }`}
          disabled={readOnly}
        />

        <span className=" font-italic text-muted font-weight-bold text-xs mx-2">
          Ocultar título
        </span>
        <GenericToggle
          actionFunction={() => {
            if (testGroupData?.hideTitle) {
              handleHideTitle(false);
            } else {
              handleHideTitle(true);
            }
          }}
          defaultActive={testGroupData?.hideTitle}
          disabled={readOnly}
        />

        <span className=" font-italic text-muted font-weight-bold text-xs mx-2">
          Confir. Automatica
        </span>
        <GenericToggle
          actionFunction={() => {
            if (testGroupData?.isAutomaticContinue) {
              handleIsAutomaticContinue(false);
            } else {
              handleIsAutomaticContinue(true);
            }
          }}
          disabled={readOnly}
          defaultActive={testGroupData?.isAutomaticContinue}
        />
        <span className=" font-italic text-muted font-weight-bold text-xs mx-2">
          {t('WITHOUT_TIME_LIMIT')}
        </span>
        <GenericToggle
          actionFunction={() => {
            handleWithoutTime(!testGroupData?.withoutTime);
          }}
          disabled={readOnly}
          defaultActive={testGroupData?.withoutTime}
        />
      </div>
    )}
    <div className="d-flex justify-content-between align-items-center my-4">
      {isEdit && testGroupData?.description ? (
        <div className="d-flex my-3 flex-column w-100 mr-5">
          <span className=" font-weight-bold text-base my-1">
            {t('CREATE_TEST_GROUP_DESCRIPTION_TITLE')}
          </span>
          <textarea
            disabled
            name="description"
            className={`border-thin-blue-principal outline-none w-100 p-2 text-xs  min-height-textarea-description ${
              testGroupData?.description?.length ? 'selected-border' : 'unselected-border'
            }`}
            rows="5"
            placeholder={t('CREATE_TEST_GROUP_NAME_PLACEHOLDER')}
            onChange={handleModifyData}
            value={testGroupData?.description ?? ''}
            maxLength={5000}
          />
        </div>
      ) : null}

      <div className="w-50 d-flex flex-column">
        <div className="d-flex flex-column justify-content-between w-100 screening-switch border-thin-blue-principal">
          <div className="d-flex justify-content-between">
            <span className="font-weight-500  text-xs">{t('CHALLENGE_ALKEMY_TOGGLE_TEXT')}</span>
            <GenericToggle
              actionFunction={() => {
                setChallengeAlkemy((state) => !state);
                if (testgroupWithThemes) setTestgroupWithThemes(false);
              }}
              defaultActive={challengeAlkemy}
              isEditTG={isEdit}
              disabled={readOnly}
            />
          </div>
          <div>
            <DropDownSelect
              className="b-radius-8 mr-4 technologies-dropdown"
              options={technologies}
              disabled={!challengeAlkemy || isEdit || readOnly}
              arrowDisabled={!challengeAlkemy}
              selected={
                challengeAlkemy &&
                (technologies.find((technology) => technology?.selected)?.id || techChallengeAlkemy)
              }
              setState={(selectedOption) =>
                handleFilterChange(technologies, setTechnologies, selectedOption)
              }
              placeholder={
                challengeAlkemy
                  ? technologies.find((tech) => tech.selected)?.name ||
                    t('CHALLENGE_ALKEMY_SELECT_DEFAULT')
                  : t('CHALLENGE_ALKEMY_SELECT_DEFAULT')
              }
              selectedPlaceholder
            />
          </div>
        </div>
      </div>
    </div>
  </>
);
